import React from "react"
import VersusPage from "../../templates/hotels/VersusPage"

const Page = () => <VersusPage duelKey="monteverdiVsRosewood" locale="en" />

export default Page
